import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _dec, _dec2, _class, _class2;
/*
 *                     NOTICE
 *            COPYRIGHT 2018 - 2019 Ab Initio
 *       UNPUBLISHED -- ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { NavigationService } from "abreact/incubator/ui/app/NavigationService";
import { AbLabel } from "abreact/incubator/ui/component/AbLabel";
import { BaseRCmp } from "abreact/incubator/ui/component/BaseRCmp";
import { LocalePreferenceMachine } from "abreact/incubator/ui/locale/LocalePreferenceMachine";
import { PopupUtils } from "abreact/incubator/ui/popup/PopupUtils";
import { AbRadioButton } from "abreact/input/AbRadioButton";
import { AbHSeparator } from "abreact/layout/AbHSeparator";
import { AbHBox } from "absdk/commons/ui/layout/AbHBox";
import { AbBusyIndicator } from "absdk/commons/ui/misc/AbBusyIndicator";
import { AbImage } from "absdk/commons/ui/misc/AbImage";
import { AbDialog } from "absdk/commons/ui/popup/AbDialog";
import { AbDialogButtonBar } from "absdk/commons/ui/popup/AbDialogButtonBar";
import * as AbWebResources from "abweb/generated/locale/AbWebResources";
import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
export const localeChoiceDataTestIdPrefix = "locale-choice-";
export let LocalePreferenceDialog = (_dec = action.bound, _dec2 = action.bound, observer(_class = (_class2 = class LocalePreferenceDialog extends BaseRCmp {
  constructor(localePreferenceDialogProps) {
    super(localePreferenceDialogProps);
    makeObservable(this);
  }
  static show() {
    PopupUtils.showPopupExplicitly(/*#__PURE__*/React.createElement(LocalePreferenceDialog, {
      machine: new LocalePreferenceMachine()
    }));
  }
  render() {
    // Discussion with Ben/Sinan: do NOT invoke the NavigationService::continueAfterNoDirtyRoutes method
    // to save all individual dirty routes via route-specific 'veto dialogs' (e.g., save/discard)
    // as the dialogs would be displayed in 'old/wrong' language.  See ABSDK-3961 for more details
    return /*#__PURE__*/React.createElement(AbDialog, {
      title: AbWebResources.localePreferenceDlg_title(),
      className: "ab-locale-preference-dialog",
      onCancel: this.onCancelClicked,
      buttonBar: /*#__PURE__*/React.createElement(AbDialogButtonBar, {
        cancelButton: true,
        okButton: true,
        onOk: this.onOKClicked
      })
    }, this.props.machine.state === "ready" ? /*#__PURE__*/React.createElement(AbHBox, {
      className: "ab-locale-hbox",
      spacing: true
    }, /*#__PURE__*/React.createElement(AbImage, {
      image: "absdk:language",
      width: "48px",
      height: "48px",
      altText: ''
    }), /*#__PURE__*/React.createElement("span", null, "\xA0"), /*#__PURE__*/React.createElement("div", {
      className: "ab-locale-preference-form"
    }, /*#__PURE__*/React.createElement(AbLabel, {
      className: "ab-locale-preference-prompt",
      label: this.props.machine.i18nPrompt,
      wrapText: true
    }), /*#__PURE__*/React.createElement("div", {
      className: "ab-locale-group-of-options"
    }, /*#__PURE__*/React.createElement(AbRadioButton, {
      groupName: "grpLocale",
      id: "rdoDefaultLocale",
      value: this.props.machine.localeIndex === -1,
      onChange: () => this.onLocaleChanged(-1),
      label: AbReactResources.locale_default_label()
    }), /*#__PURE__*/React.createElement(AbHSeparator, null), this.props.machine.localeChoices.map((choice, index) => {
      const label = choice.nativeLanguage && choice.translatedLanguage ? /*#__PURE__*/React.createElement("span", {
        lang: this.props.machine.localeAtIndex(this.props.machine.localeIndex)
      }, /*#__PURE__*/React.createElement("span", {
        lang: choice.locale
      }, choice.nativeLanguage), " ", "(", choice.translatedLanguage, ")") : choice.translatedLanguage ?? choice.locale;
      return /*#__PURE__*/React.createElement(AbRadioButton, {
        key: index,
        groupName: "grpLocale",
        dataTestId: localeChoiceDataTestIdPrefix + this.props.machine.localeAtIndex(index),
        value: this.props.machine.localeIndex === index,
        onChange: () => this.onLocaleChanged(index),
        label: label
      });
    })), NavigationService.getSingleton().routeRenderContextMgr.hasUnsavedChanges() ? /*#__PURE__*/React.createElement(AbLabel, {
      className: "ab-locale-preference-info",
      label: this.splitOnParen(this.props.machine.i18nInfo),
      wrapText: true
    }) : "")) : /*#__PURE__*/React.createElement(AbBusyIndicator, null));
  }
  splitOnParen(label) {
    // See ABSDK-557 where want the info prompt to wrap starting with the '('.
    // If '(' does not exist in locale-specific translation, gracefully degrades to normal wrapping behavior.
    // Note all observed language translations are using '(' characters (even ja and cn-ZH).
    const parenIndex = label.indexOf("(");
    return parenIndex <= 0 ? label : /*#__PURE__*/React.createElement(React.Fragment, null, label.substr(0, parenIndex), /*#__PURE__*/React.createElement("br", null), label.substring(parenIndex));
  }
  componentDidMount() {
    this.props.machine.prepare();
  }
  onLocaleChanged(value) {
    this.props.machine.localeIndex = value;
  }
  async onCancelClicked() {
    this.props.machine.setCancelled();
    return true;
  }
  onOKClicked() {
    return this.props.machine.commit();
  }
}, _applyDecoratedDescriptor(_class2.prototype, "onLocaleChanged", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "onLocaleChanged"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onCancelClicked", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "onCancelClicked"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onOKClicked", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "onOKClicked"), _class2.prototype), _class2)) || _class);
//# sourceMappingURL=LocalePreferenceDialog.js.map
